import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./FloatingWhatsApp.css";

export default function FloatingWhatsApp() {
  const phone = "966920033239";
  const message = encodeURIComponent(
    "مرحبًا، أريد الاستفسار عن خدمات التنظيم للسفر والسياحة"
  );

  return (
    <a
      href={`https://wa.me/${phone}?text=${message}`}
      className="floating-whatsapp"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="خدمة العملاء والشكاوى عبر واتساب 24/7"
    >
      <FaWhatsapp />
      <span>دعم 24/7</span>
    </a>
  );
}